module.exports = __webpack_public_path__ + "img/school-outline.01ded884.svg";